import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-prazos',
  template: `
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{titulo}}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <p>Tipo: {{tipo}} <br> <strong> Prazo: {{data}} </strong></p>
      <label>Descrição</label>
      <textarea  rows="10"  class="form-control" readonly>{{descricao}}</textarea>
      </div>
      <div class="modal-footer">
       <button type="button" class="btn btn-success" (click)="onCofirmar()">Iniciar</button>      
        <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Irei fazer depois</button>
      </div>
    `
})
export class ModalPrazosComponent {
  titulo: string;
  descricao: string;
  tipo: string;
  data: string;

  constructor(public bsModalRef: BsModalRef) {
    this.titulo = "Você possui um prazo a comprir";
  }

  confirmar: () => void;

  onCofirmar() {

    this.confirmar();
    this.bsModalRef.hide()
  }
}